import styled from "styled-components";
import Box from "../box";
const Footer = styled(Box).withConfig({
  displayName: "footer__Footer",
  componentId: "sc-1gasyet-0"
})([""]);
Footer.defaultProps = {
  as: "footer"
};
export default Footer;